var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "notifications notifications--overview loading-wrapper",
      class: { "is-loading": _vm.loading },
    },
    [
      _c("div", { staticClass: "loading-message" }, [
        _vm._v(_vm._s(this.$t("results_loading"))),
      ]),
      _vm._v(" "),
      _vm.notificationsCount === 0
        ? [
            _c("div", { staticClass: "notifications--overview__empty-item" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("notifications.no_results_found")) +
                  "\n        "
              ),
            ]),
          ]
        : _vm._l(_vm.notifications, function (item) {
            return [
              _c(
                "div",
                { staticClass: "notifications--overview__item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: item.route, title: item.title } },
                    [
                      _c("h2", [_vm._v(_vm._s(item.title))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item.description))]),
                    ]
                  ),
                ],
                1
              ),
            ]
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }